import Layout from '@/layout'

const route = {
  path: '/center',
  component: Layout,
  // redirect: '/avataracquisition/index',
  alwaysShow: true, // will always show the root menu
  name: 'center',
  meta: {
    title: '运营中心',
    icon: 'diy-YpYyVsXn',
    roles: [
      'operate'
    ]
  },
  children: [
    // 消息中心
    {
      path: '/messagecenterone/index',
      name: 'Messagecenterone',
      component: () => {
        return import('@/views/messagecenter/index.vue')
      },
      meta: {
        title: '消息中心',
        roles: [
          'message.center'
        ]
      },
      children: [
        // 推送列表
        {
          path: '/messagecentertwo/index',
          name: 'messagecentertwo',
          component: () => {
            return import('@/views/messagecenter/index.vue')
          },
          meta: {
            title: '推送列表',
            roles: [
              'push.list'
            ]
          },
          children: [
            // 推送列表
            {
              path: '/timedPushlist/index',
              component: () => import('@/views/timedPushlist/index.vue'),
              name: 'timedPushlist',
              meta: {
                title: '定时消息推送',
                // icon: 'component',
                roles: [
                  'timingPush.list'
                ]
              }
            },
            // 群发推送
            {
              path: '/officialaccountempush/index',
              component: () => import('@/views/officialaccountempush/index.vue'),
              name: 'officialaccountempush',
              meta: {
                title: '群发推送',
                // icon: 'component',
                roles: [
                  'timingPushArtc.list'
                ]
              }
            },
            // {
            //   path: '/massdispatch/index',
            //   component: () => import('@/views/massdispatch/index.vue'),
            //   name: 'massdispatch',
            //   meta: {
            //     title: '新增群发',
            //     // icon: 'component',
            //     roles: [
            //       'timingPushArtc.list'
            //     ]
            //   },
            //   hidden: true
            // },
            // 群发轮询（预览）
            {
              path: '/masspoLling/index',
              component: () => import('@/views/masspoLling/index.vue'),
              name: 'masspoLling',
              meta: {
                title: '群发轮询(预览)',
                // icon: 'component',
                roles: [
                  'timingPushArtcPreview.list'
                ]
              }
            },
            {
              path: '/numberTemplatemessage/index',
              component: () => import('@/views/numberTemplatemessage/index.vue'),
              name: 'NumberTemplatemessage',
              meta: {
                title: '单号模板消息',
                // icon: 'component',
                roles: [
                  'templateMessageLib.list'
                ]
              }
            }
            // {
            //   path: '/masspollingList/index',
            //   component: () => import('@/views/masspollingList/index.vue'),
            //   name: 'masspollingList',
            //   meta: {
            //     title: '群发轮询(预览)新增',
            //     // icon: 'component',
            //     roles: [
            //       'timingPushArtcPreview.list'
            //     ]
            //   },
            //   hidden: true
            // }
          ]
        },
        // 消息模板
        {
          path: '/messagecenterthree/index',
          name: 'messagecenterthree',
          component: () => {
            return import('@/views/messagecenter/index.vue')
          },
          meta: {
            title: '消息模板',
            roles: [
              'message.template'
            ]
          },
          children: [

            {
              path: 'customerService/index',
              component: () => import('@/views/customerService/index.vue'),
              name: 'sourceMaterial',
              meta: {
                title: '消息模板',
                // icon: 'component',
                roles: [
                  'templateAdmin.list'
                ]
              }
            },
            {
              path: '/offiaccountemlist/index',
              component: () => import('@/views/offiaccountemlist/index.vue'),
              name: 'offiaccountemlist',
              meta: {
                title: '群发模板',
                // icon: 'component',
                roles: [
                  'officialAccount.articlesList'
                ]
              }
            }
            // {
            //   path: '/accountPush/index',
            //   component: () => import('@/views/accountPush/index.vue'),
            //   // name: 'AccountPush',
            //   meta: {
            //     title: '新增群发模板',
            //     // icon: 'component',
            //     roles: [
            //       'officialAccount.articlesList'
            //     ]
            //   },
            //   hidden: true
            // }

          ]

        },
        // 策略列表
        {
          path: '/messagecentersix/index',
          name: 'messagecentersix',
          component: () => {
            return import('@/views/messagecenter/index.vue')
          },
          meta: {
            title: '策略列表',
            roles: [
              'strategy.index'
            ]
          },
          children: [
            // 策略列表
            {
              path: '/customerServicelist/index',
              component: () => import('@/views/customerServicelist/index.vue'),
              name: 'sourceMaterial',
              meta: {
                title: '策略列表',
                // icon: 'component',
                roles: [
                  'strategy.index'
                ]
              }
            }

          ]

        },
        // 预览模式群发
        {
          path: '/strategyPreview/index',
          component: () => {
            return import('@/views/strategyPreview/index.vue')
          },
          name: 'strategyPreview',
          meta: {
            title: '预览模式群发',
            // icon: 'component',
            roles: [
              'strategyPreview.index'
            ],
            children: [
              // 新增
              // 编辑
              {
                path: '/editStrategyPreview',
                component: () => import('@/views/strategyPreview/components/editStrategyPreview.vue'),
                name: 'StrategyPreview',
                meta: {
                  title: '编辑预览群发',
                  // icon: 'componentr',
                  roles: [
                    'strategyPreview.index'
                  ]
                },
                hidden: true
              }
            ]
          }
        }
      ]

    },
    // 用户中心
    {
      path: '/userlistcenter/index',
      name: 'Messagecenterone',
      component: () => {
        return import('@/views/messagecenter/index.vue')
      },
      meta: {
        title: '用户中心',
        roles: [
          'user.center'
        ]
      },
      children: [
        // 平台标签
        {
          path: '/platformLabel/index',
          component: () => import('@/views/platformLabel/index.vue'),
          name: 'platformLabel',
          meta: {
            title: '平台标签',
            // icon: 'component',
            roles: [
              'tags.platform_tags_index'
            ]
          }
        },
        // 标签组
        {
          path: '/labelGroup/index',
          component: () => import('@/views/labelGroup/index.vue'),
          name: 'labelGroup',
          meta: {
            title: '标签组',
            // icon: 'component',
            roles: [
              'tags.admin_group_index'
            ]
          }
        },
        // 运营用户列表
        {
          path: '/operateuserlist/index',
          component: () => import('@/views/operateuserlist/index.vue'),
          name: 'operateuserlist',
          meta: {
            title: '运营用户列表',
            // icon: 'component',
            roles: [
              'user.getList'
            ]
          }
        }
      ]
    },
    // 活动中心
    {
      path: '/activitycenter/index',
      name: 'Messagecenterone',
      component: () => {
        return import('@/views/messagecenter/index.vue')
      },
      meta: {
        title: '活动中心',
        roles: [
          'activity'
        ]
      },
      children: [
        // 红包活动
        {
          path: '/redEnvelopeActivity/index',
          component: () => import('@/views/redEnvelopeActivity/index.vue'),
          name: 'redEnvelopeActivity',
          meta: {
            title: '红包活动',
            // icon: 'component',
            roles: [
              'activity.redPacket.list'
            ]
          }
        },
        {
          path: '/activityList/index',
          component: () => import('@/views/activityList/index.vue'),
          name: 'activityList',
          meta: {
            title: '书城活动',
            // icon: 'component',
            roles: [
              'bookPlatform.activityTemplate.index'
            ]
          }
        },
        // 书城推广链接
        {
          path: '/extensionlink/index',
          component: () => import('@/views/extensionlink/index.vue'),
          name: 'extensionlink',
          meta: {
            title: '书城推广链接',
            // icon: 'component',
            roles: [
              'bookPlatform.promotionLinkTemplate.getList'
            ]
          }
        }
        // 充值活动返现
        // {
        //   path: '/rechargecashback/index',
        //   component: () => import('@/views/rechargecashback/index.vue'),
        //   name: 'rechargecashback',
        //   meta: {
        //     title: '充值活动返现',
        //     // icon: 'component',
        //     roles: [
        //       'bookPlatform.promotionLinkTemplate.getList'
        //     ]
        //   }
        // }
      ]
    },
    // 小程序管理
    {
      path: '/appletscenter/index',
      name: 'Messagecenterone',
      component: () => {
        return import('@/views/messagecenter/index.vue')
      },
      meta: {
        title: '小程序管理',
        roles: [
          'miniProgram'
        ]
      },
      children: [
        // {
        //   path: '/Video/index',
        //   name: 'Video',
        //   component: () => {
        //     return import('@/views/messagecenter/index.vue')
        //   },
        //   meta: {
        //     title: '短视频活动',
        //     roles: [
        //       'appletVideo'
        //     ]
        //   },
        //   children: [
        //     {
        //       path: '/appLookVideo/index',
        //       name: 'appLookVideo',
        //       component: () => {
        //         return import('@/views/appLookVideo/index.vue')
        //       },
        //       meta: {
        //         title: '短视频',
        //         roles: [
        //           'appletVideo.videoSetting.list'
        //         ]
        //       }
        //     },
        {
          path: '/articlerecommendation/index',
          name: 'articlerecommendation',
          component: () => {
            return import('@/views/articlerecommendation/index.vue')
          },
          meta: {
            title: '文章',
            roles: [
              'appletVideo.articleSetting.list'
            ]
          }
        },
        {
          path: '/wechatReportlist/index',
          name: 'wechatReportlist',
          component: () => {
            return import('@/views/wechatReportlist/index.vue')
          },
          meta: {
            title: '用户投诉列表',
            roles: [
              'userReportList'
            ]
          }
        },
        //     {
        //       path: '/appvideoAD/index',
        //       component: () => import('@/views/appvideoAD/index.vue'),
        //       name: 'appvideoAD',
        //       meta: {
        //         title: '视频广告配置',
        //         // icon: 'component',
        //         roles: [
        //           'appletVideo.videoAdSetting.list'
        //         ]
        //       }
        //     },
        //     {
        //       path: '/cookiecreate/index',
        //       component: () => import('@/views/cookiecreate/index.vue'),
        //       name: 'cookiecreate',
        //       meta: {
        //         title: 'cookie列表',
        //         // icon: 'component',
        //         roles: [
        //           'appletVideo.operateCookie.list'
        //         ]
        //       }
        //     }
        //   ]

        // },
        {
          path: '/blessingvideo/index',
          name: 'Blessingvideo',
          component: () => {
            return import('@/views/messagecenter/index.vue')
          },
          meta: {
            title: '祝福视频',
            roles: [
              'appletLifeVideo'
            ]
          },
          children: [
            {
              path: '/blessingVideo/index',
              name: 'BlessingVideo',
              component: () => {
                return import('@/views/blessingVideo/index.vue')
              },
              meta: {
                title: '短视频',
                roles: [
                  'appletLifeVideo.videoSetting.videoList'
                ]
              }
            },
            // {
            //   path: '/blessingappvideoAD/index',
            //   component: () => import('@/views/blessingappvideoAD/index.vue'),
            //   name: 'BlessingappvideoAD',
            //   meta: {
            //     title: '视频广告配置',
            //     // icon: 'component',
            //     roles: [
            //       'appletLifeVideo.videoAdSetting.list'
            //     ]
            //   }
            // },
            {
              path: '/appvideoAD/index',
              component: () => import('@/views/appvideoAD/index.vue'),
              name: 'appvideoAD',
              meta: {
                title: '视频广告配置',
                // icon: 'component',
                roles: [
                  'appletVideo.videoAdSetting.list'
                ]
              }
            },
            {
              path: '/sourceminiprogram/index',
              component: () => import('@/views/sourceminiProgram/index.vue'),
              name: 'SourceminiProgram',
              meta: {
                title: '来源小程序',
                // icon: 'component',
                roles: [
                  'appletLifeVideo.videoSetting.list'
                ]
              }
            },
            {
              path: '/targetclassification/index',
              component: () => import('@/views/targetClassification/index.vue'),
              name: 'TargetClassification',
              meta: {
                title: '目标分类',
                // icon: 'component',
                roles: [
                  'appletLifeVideo.videoCategory.list'
                ]
              }
            },
            {
              path: '/classificationassociation/index',
              component: () => import('@/views/classificationAssociation/index.vue'),
              name: 'ClassificationAssociation',
              meta: {
                title: '小程序关联分类',
                // icon: 'component',
                roles: [
                  'appletLifeVideo.videoCategoryRelation.list'
                ]
              }
            },
            {
              path: '/cookiecreate/index',
              component: () => import('@/views/cookiecreate/index.vue'),
              name: 'cookiecreate',
              meta: {
                title: 'cookie列表',
                // icon: 'component',
                roles: [
                  'appletVideo.operateCookie.list'
                ]
              }
            },
            {
              path: '/video/historydata',
              component: () => import('@/views/blessingVideo/components/videodetail.vue'),
              name: 'blessingVideohistory',
              meta: {
                title: '视频数据',
                // icon: 'component',
                roles: [
                  'appletLifeVideo.videoSetting.statistics'
                ]
              }
            }
          ]
        },
        {
          path: '/wechatgame/index',
          name: 'Blessingvideo',
          component: () => {
            return import('@/views/messagecenter/index.vue')
          },
          meta: {
            title: '微信小游戏',
            roles: [
              'wxCps'
            ]
          },
          children: [
            {
              path: '/promotionsingle/index',
              name: 'Promotionsingle',
              component: () => {
                return import('@/views/promotionsingle/index.vue')
              },
              meta: {
                title: '推广单游戏',
                roles: [
                  'wxCps.gameList.list'
                ]
              }
            },
            {
              path: '/Cpsoption/index',
              name: 'CpsopTion',
              component: () => {
                return import('@/views/Cpsoption/index.vue')
              },
              meta: {
                title: 'CPS配置',
                roles: [
                  'wxCps.setting.list'
                ]
              }
            },
            {
              path: '/wechatGame/index',
              component: () => import('@/views/wechatGame/index.vue'),
              name: 'WechatGame',
              meta: {
                title: '小游戏配置',
                // icon: 'component',
                roles: [
                  'wxCps.gameSetting.list'
                ]
              }
            },
            {
              path: '/linkList/index',
              component: () => import('@/views/linkList/index.vue'),
              name: 'LinkList',
              meta: {
                title: 'cps链接列表',
                // icon: 'component',
                roles: [
                  'wxCps.promotion.list'
                ]
              }
            }
          ]
        },
        // 转盘活动
        {
          path: '/appletslist/index',
          name: 'appletslist',
          component: () => {
            return import('@/views/messagecenter/index.vue')
          },
          meta: {
            title: '转盘活动',
            roles: [
              'Turntable'
            ]
          },
          children: [
            {
              path: '/luckdraw/index',
              component: () => import('@/views/luckDraw/index.vue'),
              name: 'sourceMaterial',
              meta: {
                title: '转盘抽奖配置',
                // icon: 'component',
                roles: [
                  'activity.Turntable.turntableConfigList'
                ]
              }
            },
            {
              path: '/appletsconfigure/index',
              component: () => import('@/views/appletsconfigure/index.vue'),
              name: 'sourceMaterial',
              meta: {
                title: '小程序绑定配置',
                // icon: 'component',
                roles: [
                  'activity.Turntable.turntableConfigBindList'
                ]
              }
            },
            {
              path: '/applets/index',
              component: () => import('@/views/applets/index.vue'),
              name: 'applets',
              meta: {
                title: '转盘用户',
                // icon: 'component',
                roles: [
                  'activity.Turntable.TurntableUserList'
                ]
              }
            }
            // {
            //   path: '/exchange/index',
            //   component: () => import('@/views/exchange/index.vue'),
            //   name: 'exchange',
            //   meta: {
            //     title: '兑换记录',
            //     icon: 'component',
            //     roles: [
            //       'activity.Turntable.TurntableUserList'
            //     ]
            //   },
            //   hidden: true
            // },
            // {
            //   path: '/luckdrawlist/index',
            //   component: () => import('@/views/luckdrawlist/index.vue'),
            //   name: 'luckdrawlist',
            //   meta: {
            //     title: '抽奖记录',
            //     icon: 'component',
            //     roles: [
            //       'activity.Turntable.TurntableUserList'
            //     ]
            //   },
            //   hidden: true
            // },
            // {
            //   path: '/signinlist/index',
            //   component: () => import('@/views/signinlist/index.vue'),
            //   name: 'signinlist',
            //   meta: {
            //     title: '签到记录',
            //     icon: 'component',
            //     roles: [
            //       'activity.Turntable.TurntableUserList'
            //     ]
            //   },
            //   hidden: true
            // }

          ]

        },
        // 九宫格活动
        {
          path: '/squaredpaper/index',
          name: 'squaredpaper',
          component: () => {
            return import('@/views/messagecenter/index.vue')
          },
          meta: {
            title: '九宫格活动',
            roles: [
              'ninesquares'
            ]
          },
          children: [
            {
              path: '/squaredPaper/index',
              component: () => import('@/views/squaredPaper/index.vue'),
              name: 'squaredPaper',
              meta: {
                title: '九宫格抽奖配置',
                // icon: 'component',
                roles: [
                  'activity.ninesquares.nineSquaresConfigList'
                ]
              }
            },
            {
              path: '/squaredappletSconfigure/index',
              component: () => import('@/views/squaredappletSconfigure/index.vue'),
              name: 'squaredappletSconfigure',
              meta: {
                title: '小程序绑定配置',
                // icon: 'component',
                roles: [
                  'activity.ninesquares.nineSquaresConfigBindList'
                ]
              }
            },
            {
              path: '/squaredpaperApplets/index',
              component: () => import('@/views/squaredpaperApplets/index.vue'),
              name: 'squaredpaperApplets',
              meta: {
                title: '九宫格用户',
                // icon: 'component',
                roles: [
                  'activity.ninesquares.ninesquaresUserList'
                ]
              }
            }

          ]

        },
        // 找茬活动
        {
          path: '/seelooklist/index',
          name: 'seelooklist',
          component: () => {
            return import('@/views/messagecenter/index.vue')
          },
          meta: {
            title: '找茬活动',
            roles: [
              'appletFindDifferent'
            ]
          },
          children: [
            {
              path: '/seelookList/index',
              component: () => import('@/views/seelookList/index.vue'),
              name: 'seelookList',
              meta: {
                title: '找茬小程序列表',
                // icon: 'component',
                roles: [
                  'appletFindDifferent.iconsSet.list'
                ]
              }
            },
            {
              path: '/seelooktypeList/index',
              component: () => import('@/views/seelooktypeList/index.vue'),
              name: 'seelooktypeList',
              meta: {
                title: '找茬分类配置',
                // icon: 'component',
                roles: [
                  'appletFindDifferent.assort.list'
                ]
              }
            }

          ]

        },
        {
          path: '/appletedition/index',
          component: () => import('@/views/appletedition/index.vue'),
          name: 'sourceMaterial',
          meta: {
            title: '版本发布',
            // icon: 'component',
            roles: [
              'mpDrafts.list'
            ]
          }
        },
        {
          path: '/turntableadvertisement/index',
          component: () => import('@/views/turntableadvertisement/index.vue'),
          name: 'sourceMaterial',
          meta: {
            title: '小程序广告',
            // icon: 'component',
            roles: [
              'officialAccount.getMiniProgramAdList'
            ]
          }
        },
        {
          path: '/wechatbinding/index',
          component: () => import('@/views/wechatbinding/index.vue'),
          name: 'wechatbinding',
          meta: {
            title: '关联公众号',
            // icon: 'component',
            roles: [
              'officialAccount.bindmpList'
            ]
          }
        },
        {
          path: '/backstageapplets/index',
          component: () => import('@/views/backstageapplets/index.vue'),
          name: 'backstageapplets',
          meta: {
            title: '小程序列表',
            // icon: 'component',
            roles: [
              'officialAccount.getList'
            ]
          }
        },

        {
          path: '/miniProgramPhotoGallery/index',
          component: () => import('@/views/messagecenter/index.vue'),
          name: 'MiniProgramPhotoGallery',
          meta: {
            title: '小程序图库',
            // icon: 'component',
            roles: [
              'appletPhotos'
            ]
          },
          children: [
            {
              path: '/miniProgramPhotoGalleryList/index',
              component: () => import('@/views/miniProgramPhotoGalleryList/index.vue'),
              name: 'miniProgramPhotoGalleryList',
              meta: {
                title: '图库',
                // icon: 'component',
                roles: [
                  'appletPhotos.setNumber.index'
                ]
              }
            },
            {
              path: '/miniProgramPhotoLookCount/index',
              component: () => import('@/views/miniProgramPhotoLookCount/index.vue'),
              name: 'miniProgramPhotoLookCount',
              meta: {
                title: '查看次数配置',
                // icon: 'component',
                roles: [
                  'appletPhotos.gallery.list'
                ]
              }
            }
          ]
        },
        {
          path: '/wechatseting/index',
          component: () => import('@/views/wechatseting/index.vue'),
          name: 'Wechatseting',
          meta: {
            title: '小程序优先级设置',
            // icon: 'component',
            roles: [
              'officialAccount.listMpRank'
            ]
          }
        }
      ]
    },
    // 公众号管理
    {
      path: '/accountlisrt/index',
      name: 'Messagecenterone',
      component: () => {
        return import('@/views/messagecenter/index.vue')
      },
      meta: {
        title: '公众号管理',
        roles: [
          'officialAccount'
        ]
      },
      children: [
        {
          path: '/accountList/officialaccountList',
          component: () => import('@/views/accountList/officialaccountList.vue'),
          name: 'materialCenter',
          meta: {
            title: '公众号列表',
            // icon: 'component',
            roles: [
              'officialAccount.index'
            ]
          }
        },
        // 素材中心
        {
          path: '/sourceMaterial/index',
          component: () => import('@/views/sourceMaterial/index.vue'),
          name: 'materialCenter',
          meta: {
            title: '素材中心',
            // icon: 'component',
            roles: [
              'sourceMaterial.list'
            ]
          }
        },
        // 模板消息配置
        {
          path: '/wechattemplateme/index',
          component: () => import('@/views/wechattemplateme/index.vue'),
          name: 'sourceMaterial',
          meta: {
            title: '模板消息配置',
            // icon: 'component',
            roles: [
              'templateMessageLib.index'
            ]
          }
        },
        // 公众号菜单
        {
          path: 'menutemplateList/index',
          component: () => import('@/views/menutemplateList/index.vue'),
          name: 'sourceMaterial',
          meta: {
            title: '公众号菜单',
            // icon: 'component',
            roles: [
              'menuTemplate.index'
            ]
          }
        },
        {
          path: '/risktesting/index',
          component: () => import('@/views/risktesting/index.vue'),
          name: 'risktesting',
          meta: {
            title: '接口检测',
            // icon: 'component',
            roles: [
              'risk.oatesting.list'
            ]
          }
        },
        // {
        //   path: '/officialaccountlook/index',
        //   component: () => import('@/views/officialaccountlook/index.vue'),
        //   name: 'officialaccountlook',
        //   meta: {
        //     title: '公众号详情',
        //     // icon: 'component',
        //     roles: [
        //       'officialAccount.index'
        //     ]
        //   },
        //   hidden: true
        // },
        {
          path: '/relationaccountnumber/index',
          component: () => import('@/views/relationaccountnumber/index.vue'),
          name: 'relationaccountnumber',
          meta: {
            title: 'AB号关联',
            // icon: 'component',
            roles: [
              'officialRelation.mainSublist'
            ]
          }
        },
        {
          path: '/labelmanagement/index',
          component: () => import('@/views/labelmanagement/index.vue'),
          name: 'sourceMaterial',
          meta: {
            title: '公众号标签管理',
            // icon: 'component',
            roles: [
              'officialAccountTags'
            ]
          }
        }
      ]
    },
    // 书城管理
    {
      path: '/bookcenter/index',
      name: 'Messagecenterone',
      component: () => {
        return import('@/views/messagecenter/index.vue')
      },
      meta: {
        title: '书城管理',
        roles: [
          'bookplatform.manager'
        ]
      },
      children: [
        // 平台标签
        {
          path: '/platformSetting/index',
          component: () => import('@/views/platformSetting/index.vue'),
          name: 'platformSetting',
          meta: {
            title: '平台',
            // icon: 'component',
            roles: [
              'bookPlatform.index'
            ]
          }
        },
        {
          path: '/messagecenter/index',
          component: () => import('@/views/messagecenter/index.vue'),
          name: 'messagecenter'
          // meta: {
          //   title: '平台',
          //   // icon: 'component',
          //   roles: [
          //     'bookPlatform.index'
          //   ]
          // },
          // hidden: true
        }
      ]
    },
    // 运营周边
    {
      path: '/surroundingoperations/index',
      name: 'Messagecenterone',
      component: () => {
        return import('@/views/messagecenter/index.vue')
      },
      meta: {
        title: '运营周边',
        roles: [
          'periphery'
        ]
      },
      children: [
        // 平台标签
        {
          path: '/surroundingList/index',
          component: () => import('@/views/surroundingList/index.vue'),
          name: 'surroundingList',
          meta: {
            title: '二级跳转',
            // icon: 'component',
            roles: [
              'periphery.secondaryJump.list'
            ]
          }
        },
        {
          path: '/messagecenter/index',
          component: () => import('@/views/messagecenter/index.vue'),
          name: 'messagecenter'
          // meta: {
          //   title: '平台',
          //   // icon: 'component',
          //   roles: [
          //     'bookPlatform.index'
          //   ]
          // },
          // hidden: true
        }
      ]
    },
    // 企业微信2
    // {
    //   path: '/messagecenterfour/index',
    //   name: 'Messagecenterone',
    //   component: () => {
    //     return import('@/views/messagecenter/index.vue')
    //   },
    //   meta: {
    //     title: '企业微信2',
    //     roles: [
    //       'spWorkWechat'
    //     ]
    //   },
    //   children: [
    //     {
    //       path: 'enterprisemilist/index',
    //       component: () => import('@/views/enterprisemilist/index.vue'),
    //       name: 'sourceMaterial',
    //       meta: {
    //         title: '企微策略列表',
    //         // icon: 'component',
    //         roles: [
    //           'spWorkWechat.strategy.list'
    //         ]
    //       }
    //     },
    //     {
    //       path: 'enterpmessagelist/index',
    //       component: () => import('@/views/enterpmessagelist/index.vue'),
    //       name: 'sourceMaterial',
    //       meta: {
    //         title: '企微消息列表',
    //         // icon: 'component',
    //         roles: [
    //           // 'spWorkWechat.spMessage.list'
    //           'spWorkWechat.spMessage.list'
    //         ]
    //       }
    //     },
    //     {
    //       path: 'wechatlist/index',
    //       component: () => import('@/views/wechatlist/index.vue'),
    //       name: 'sourceMaterial',
    //       meta: {
    //         title: '企微群列表',
    //         // icon: 'component',
    //         roles: [
    //           // 'spWorkWechat.spMessage.list'
    //           'spWorkWechat.spChatGroup.index'
    //         ]
    //       }
    //     },
    //     {
    //       path: '/enterpriseAstaff/index',
    //       component: () => import('@/views/enterpriseAstaff/index.vue'),
    //       name: 'sourceMaterial',
    //       meta: {
    //         title: '企微/员工列表',
    //         // icon: 'component',
    //         roles: [
    //           'spWorkWechat.spCorp.list'
    //         ]
    //       }
    //     },
    //     {
    //       path: 'enterprise/index',
    //       component: () => import('@/views/enterprise/index.vue'),
    //       name: 'sourceMaterial',
    //       meta: {
    //         title: '企微企业列表',
    //         // icon: 'component',
    //         roles: [
    //           'spWorkWechat.spCorp.list'
    //         ]
    //       }
    //     },
    //     {
    //       path: 'enterprisestaff/index',
    //       component: () => import('@/views/enterprisestaff/index.vue'),
    //       name: 'sourceMaterial',
    //       meta: {
    //         title: '企微企业员工列表',
    //         // icon: 'component',
    //         roles: [
    //           'spWorkWechat.spCorp.corpUsersList'
    //         ]
    //       }
    //     },
    //     {
    //       path: 'enterExternalemployees/index',
    //       component: () => import('@/views/enterExternalemployees/index.vue'),
    //       name: 'sourceMaterial',
    //       meta: {
    //         title: '外部客户列表',
    //         // icon: 'component',
    //         roles: [
    //           'spWorkWechat.spCorp.externalContactsList'
    //         ]
    //       }
    //     },
    //     {
    //       path: 'behavioralsource/index',
    //       component: () => import('@/views/behavioralsource/index.vue'),
    //       name: 'sourceMaterial',
    //       meta: {
    //         title: '行为源',
    //         // icon: 'component',
    //         roles: [
    //           'ad1.userAction.index'
    //         ]
    //       }
    //     }
    //   ]
    // },
    {
      path: '/accountPush/index',
      component: () => import('@/views/accountPush/index.vue'),
      name: 'AccountPush',
      meta: {
        title: '新增群发模板',
        // icon: 'component',
        roles: [
          'officialAccount.articlesList'
        ]
      },
      hidden: true
    },
    {
      path: '/textTemplate/index',
      component: () => import('@/views/textTemplate/index.vue'),
      name: 'textTemplate',
      meta: {
        title: '新增文本模板',
        // icon: 'component',
        roles: [
          'officialAccount.articlesList'
        ]
      },
      hidden: true
    },
    {
      path: '/audioTemplate/index',
      component: () => import('@/views/audioTemplate/index.vue'),
      name: 'audioTemplate',
      meta: {
        title: '新增音频模板',
        // icon: 'component',
        roles: [
          'officialAccount.articlesList'
        ]
      },
      hidden: true
    },
    {
      path: '/massdispatch/index',
      component: () => import('@/views/massdispatch/index.vue'),
      name: 'massdispatch',
      meta: {
        title: '新增群发',
        // icon: 'component',
        roles: [
          'timingPushArtc.list'
        ]
      },
      hidden: true
    },
    {
      path: '/masspollingList/index',
      component: () => import('@/views/masspollingList/index.vue'),
      name: 'masspollingList',
      meta: {
        title: '群发轮询(预览)新增',
        // icon: 'component',
        roles: [
          'timingPushArtcPreview.list'
        ]
      },
      hidden: true
    },
    {
      path: '/exchange/index',
      component: () => import('@/views/exchange/index.vue'),
      name: 'exchange',
      meta: {
        title: '兑换记录',
        icon: 'component',
        roles: [
          'activity.Turntable.TurntableUserList'
        ]
      },
      hidden: true
    },
    {
      path: '/luckdrawlist/index',
      component: () => import('@/views/luckdrawlist/index.vue'),
      name: 'luckdrawlist',
      meta: {
        title: '抽奖记录',
        icon: 'component',
        roles: [
          'activity.Turntable.TurntableUserList'
        ]
      },
      hidden: true
    },
    {
      path: '/signinlist/index',
      component: () => import('@/views/signinlist/index.vue'),
      name: 'signinlist',
      meta: {
        title: '签到记录',
        icon: 'component',
        roles: [
          'activity.Turntable.TurntableUserList'
        ]
      },
      hidden: true
    },
    {
      path: '/giftdeduction/index',
      component: () => import('@/views/giftdeduction/index.vue'),
      name: 'giftdeduction',
      meta: {
        title: '赠送/扣减记录',
        icon: 'component',
        roles: [
          'activity.Turntable.TurntableUserList'
        ]
      },
      hidden: true
    },
    {
      path: '/officialaccountlook/index',
      component: () => import('@/views/officialaccountlook/index.vue'),
      name: 'officialaccountlook',
      meta: {
        title: '公众号详情',
        // icon: 'component',
        roles: [
          'officialAccount.index'
        ]
      },
      hidden: true
    },
    {
      path: '/enterpridialog/index',
      component: () => import('@/views/enterprisemilist/enterpridialog.vue'),
      name: 'enterpridialog',
      meta: {
        title: '新增企微策略',
        // icon: 'component',
        roles: [
          'officialAccount.index'
        ]
      },
      hidden: true
    },
    {
      path: '/TencentAccountIni/components/addClockRules',
      component: () => import('@/views/TencentAccountIni/components/addClockRules.vue'),
      name: 'addClockRules',
      meta: {
        title: '新增打卡规则',
        roles: [
          'officialAccount.index'
        ]
      },
      hidden: true
    },
    {
      path: '/addReportRules/index',
      component: () => import('@/views/TencentAccountIni/components/addReportRules.vue'),
      name: 'addReportRules',
      meta: {
        title: '新增汇报规则',
        roles: [
          'officialAccount.index'
        ]
      },
      hidden: true
    },
    {
      path: '/updateReportRules/index',
      component: () => import('@/views/TencentAccountIni/components/addReportRules.vue'),
      name: 'updateReportRules',
      meta: {
        title: '更新汇报规则',
        roles: [
          'officialAccount.index'
        ]
      },
      hidden: true
    },
    {
      path: '/OperationStrategy/add',
      component: () => import('@/views/OperationStrategy/enterpridialog.vue'),
      name: 'OperationStrategy',
      meta: {
        title: '新增运营策略',
        // icon: 'component',
        roles: [
          'officialAccount.index'
        ]
      },
      hidden: true
    },
    {
      path: '/Qrcode',
      component: () => import('@/views/enterpriseAstaff/components/QRcode.vue'),
      name: 'Qrcode',
      meta: {
        title: '二维码',
        // icon: 'component',
        roles: [
          'officialAccount.index'
        ]
      },
      hidden: true
    },
    {
      path: '/atraddlink/index',
      component: () => import('@/views/atregulartime/components/atraddlink.vue'),
      name: 'atraddlink',
      meta: {
        title: '新增定时消息推送',
        // icon: 'component',
        roles: [
          'officialAccount.index'
        ]
      },
      hidden: true
    },
    {
      path: '/sendlink/index',
      component: () => import('@/views/enterprisemilist/components/send.vue'),
      name: 'enterpridialog',
      meta: {
        title: '发送记录',
        // icon: 'component',
        roles: [
          'officialAccount.index'
        ]
      },
      hidden: true
    },
    {
      path: '/newlyinmessage/index',
      component: () => import('@/views/enterpmessagelist/newlyinmessage.vue'),
      name: 'newlyinmessage',
      meta: {
        title: '新增消息',
        // icon: 'component',
        roles: [
          'officialAccount.index'
        ]
      },
      hidden: true
    },
    {
      path: '/addmessage/index',
      component: () => import('@/views/workWechat/addMessage.vue'),
      name: 'addmessage',
      meta: {
        title: '新增朋友圈',
        // icon: 'component',
        roles: [
          'officialAccount.index'
        ]
      },
      hidden: true
    },
    {
      path: '/seelook/index',
      component: () => import('@/views/seelook/index.vue'),
      name: 'Seelook',
      meta: {
        title: '找不同小程序配置',
        // icon: 'componentr',
        roles: [
          'appletFindDifferent.iconsSet.create'
        ]
      },
      hidden: true
    },
    {
      path: '/addStrategyPreview',
      component: () => import('@/views/strategyPreview/components/addStrategyPreview.vue'),
      name: 'addStrategyPreview',
      meta: {
        title: '新增预览群发',
        // icon: 'componentr',
        roles: [
          'strategyPreview.index'
        ]
      },
      hidden: true
    },
    {
      path: '/strategyPreview/sendHistory',
      component: () => import('@/views/strategyPreview/components/send.vue'),
      name: 'strategyPreviewSendHistory',
      meta: {
        title: '发送记录-预览模式',
        // icon: 'component',
        roles: [
          'strategyPreview.index'
        ]
      },
      hidden: true
    },
    {
      path: '/miniprogramoption/miniprogramaccess',
      component: () => import('@/views/miniprogramoption/index.vue'),
      name: 'Miniprogramoption',
      meta: {
        title: '小程序-访问数据',
        // icon: 'component',
        roles: [
          'officialAccount.getList'
        ]
      },
      hidden: true
    }
  ]

}

export default route
